<body class="d-body">
  <div class="body create-course">
    <iq-central-front-end-navbar></iq-central-front-end-navbar>
    <div class="container">
      <div class="row">
        <div class="col-lg-2 col-sm-12"></div>
        <div class="col-lg-8 col-sm-12">
          <ul class="nav nav-pills mb-3 justify-content-center mt-5">
            <li class="nav- click">
              <a class="nav-link active">
                <span class="number">1</span> COURSE OVERVIEW</a
              >
            </li>
            <li
              class="nav-item click"
              [routerLink]="['/courses/edit-lesson', courseCode]"
            >
              <a class="nav-link">
                <span class="number">2</span> EDIT LESSONS</a
              >
            </li>
            <li class="nav-item click">
              <a class="nav-link"><span class="number">3</span>CERTIFICATION</a>
            </li>
          </ul>
        </div>
        <div class="col-lg-2 col-sm-12"></div>
      </div>
    </div>

    <section>
      <div class="container">
        <form action="" [formGroup]="updateCourseForm">
          <div class="mt-5 mb-3 col-12">
            <p class="font24 text-grey">Course Title</p>
            <input
              class="largeInput"
              type="text"
              placeholder="Course Title"
              formControlName="title"
            />
          </div>

          <div class="row mt-5 mb-3 mx-0">
            <div class="col-lg-4 col-sm-12">
              <p class="font24 text-grey">Choose Course Category</p>
              <ng-select
                class="font24 text-grey"
                [items]="categories"
                [multiple]="false"
                [closeOnSelect]="true"
                [searchable]="true"
                bindLabel="name"
                bindValue="id"
                formControlName="id"
                (change)="getAllSubCategories($event)"
              >
              </ng-select>
              <div class="invalid-feedback">Please select a category</div>
            </div>

            <div class="col-lg-4 col-sm-12 sm-mt">
              <p class="font24 text-grey">Choose Sub Category</p>
              <ng-select
                appearance="outline"
                [searchable]="true"
                [closeOnSelect]="true"
                [multiple]="false"
                [clearable]="false"
                class="font24"
                labelForId="category"
                formControlName="category"
                (change)="getAllTopics($event)"
              >
                <ng-option [value]="courseData?.subCategory?.id" disabled>
                  {{ courseData?.subCategory?.name }}
                </ng-option>
                <ng-option
                  [value]="subCategory.id"
                  *ngFor="let subCategory of subCategories"
                  >{{ subCategory?.name }}</ng-option
                >
              </ng-select>
              <div class="invalid-feedback">Please select a subcategory</div>
            </div>
            <div class="col-lg-4 col-sm-12 sm-mt">
              <p class="font24 text-grey">Choose Course Topics</p>
              <ng-select
                class="font24 text-grey"
                [items]="topics"
                [multiple]="true"
                bindValue="id"
                bindLabel="name"
                [closeOnSelect]="topics.length === 1 ? true : false"
                formControlName="topics"
              >
              </ng-select>
              <div class="invalid-feedback">No topics have been selected</div>
            </div>
          </div>
          <div class="mt-4 mb-3 col-12">
            <p class="font24 text-grey">Course Description</p>
            <div class="bg-white px-1 py-3 border-radius">
              <angular-editor
                [placeholder]="'Enter text here...'"
                formControlName="description"
                [config]="config"
                [ngClass]="{
                  'is-invalid':
                    updateCourseForm.get('description').errors &&
                    updateCourseForm.get('description').touched
                }"
              ></angular-editor>
            </div>
          </div>

          <div class="row mt-5 mb-3 mx-0">
            <div class="col-lg-4 col-sm-12">
              <p class="font24 text-grey">Choose Course Level</p>
              <mat-form-field>
                <mat-select
                  formControlName="level"
                  [ngClass]="{
                    'is-invalid':
                      updateCourseForm.get('level').errors &&
                      updateCourseForm.get('level').touched
                  }"
                >
                  <mat-option value="BASIC">BASIC</mat-option>
                  <mat-option value="INTERMEDIATE">INTERMEDIATE</mat-option>
                  <mat-option value="EXPERT">EXPERT</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-lg-4 col-12">
              <p class="font24 text-grey pb-3">Course Code</p>
              <input
                type="text"
                class="largeInput"
                formControlName="courseCode"
              />
            </div>

            <div class="col-lg-4 col-sm-12 sm-mt">
              <p class="font24 text-grey font-bold duration">Course Duration</p>
              <ngb-timepicker
                required
                formControlName="duration"
                [ngClass]="{
                  'is-invalid':
                    updateCourseForm.get('duration').errors &&
                    updateCourseForm.get('duration').touched
                }"
              ></ngb-timepicker>
              <div
                class="mt-0 p-0 text-danger"
                *ngIf="updateCourseForm.get('duration').value == undefined"
              >
                Required
              </div>
              <div class="invalid-feedback mt-0 p-0">
                Please enter course duration
              </div>
            </div>
          </div>

          <div class="row mt-5 mb-3 mx-0">
            <div class="col-lg-4 col-sm-12">
              <p class="font24 text-grey font-bold">Requires Certificate?</p>
              <mat-form-field>
                <mat-select
                  formControlName="hasCertificate"
                  [ngClass]="{
                    'is-invalid':
                      updateCourseForm.get('hasCertificate').errors &&
                      updateCourseForm.get('hasCertificate').touched
                  }"
                >
                  <mat-option [value]="true">YES</mat-option>
                  <mat-option [value]="false">NO</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div
              class="col-sm-12 col-lg-4 sm-mt"
              *ngIf="updateCourseForm.get('hasCertificate').value === true"
            >
              <p class="font24 text-grey font-bold">Certificate Type</p>
              <mat-form-field>
                <mat-select
                  formControlName="certificateType"
                  [ngClass]="{
                    'is-invalid':
                      updateCourseForm.get('certificateType').errors &&
                      updateCourseForm.get('certificateType').touched
                  }"
                >
                  <mat-option value="GENERIC">GENERIC</mat-option>
                  <mat-option value="CUSTOM">CUSTOM</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div
              class="col-lg-4 col-12"
              *ngIf="updateCourseForm.get('hasCertificate').value === true"
            >
              <p class="font24 text-grey pb-3">Certificate Upload</p>
              <app-file-upload
                formControlName="certificate"
                [ngClass]="{
                  'is-invalid':
                    updateCourseForm.get('certificate').errors &&
                    updateCourseForm.get('certificate').touched
                }"
                [placeholder]="fileName"
                [elementId]="'imageFile'"
              ></app-file-upload>
            </div>
          </div>

          <div class="row mt-5 mb-3 mx-0">
            <div
              class="col-lg-4 col-12"
              *ngIf="userType === 'CONTENT_PROVIDER'"
            >
              <p class="font24 text-grey font-bold m-0">Course Type</p>
              <mat-form-field>
                <mat-select
                  class="m-0 form-control"
                  formControlName="courseType"
                  [ngClass]="{
                    'is-invalid':
                      updateCourseForm.get('courseType').errors &&
                      updateCourseForm.get('courseType').touched
                  }"
                >
                  <mat-option value="FREE">FREE</mat-option>
                  <mat-option value="PAID">PAID</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div
              class="col-lg-4 col-12"
              *ngIf="updateCourseForm.get('courseType').value === 'PAID'"
            >
              <p class="font24 text-grey pb-3">Course Price</p>
              <input
                type="text"
                class="largeInput"
                placeholder="CCCDDD$#$#"
                formControlName="coursePrice"
              />
            </div>
            <div class="col-lg-4 col-12">
              <p class="font24 text-grey pb-3">Course Picture</p>
              <app-file-upload
                formControlName="picture"
                [ngClass]="{
                  'is-invalid':
                    updateCourseForm.get('picture').errors &&
                    updateCourseForm.get('picture').touched
                }"
                [placeholder]="'Upload Image'"
                [elementId]="'courseImage'"
              ></app-file-upload>
            </div>
          </div>
          <div class="text-right my-5 d-flex justify-content-end">
            <button class="btn btn-secondary next ml-4" (click)="finish()">
              Save
            </button>
            <button
              class="btn btn-secondary next ml-4"
              (click)="addLesson('page')"
            >
              Edit lesson
              <span *ngIf="isLoading" class="ml-4"
                ><i class="fa fa-spinner fa-spin"></i
              ></span>
            </button>
          </div>
        </form>
      </div>
    </section>
    <div class="col-lg-1 col-sm-12 sm-mt"></div>
  </div>
  <div class="mt-auto">
    <div class="footer-wrapper">
      <iq-central-front-end-footer></iq-central-front-end-footer>
    </div>
  </div>
</body>
